/* eslint-disable react/jsx-props-no-spreading */
import {
    CircularProgress,
    CircularProgressProps,
} from '@mui/material'

import useStyles from './Loading.styles'

const Loading = ({
    className = '',
    ...props
}: Readonly<{
    className?: string,
} & CircularProgressProps>) => {
    const {
        classes,
        cx,
    } = useStyles()

    return (
        <div
            className={cx(classes.wrapper, className)}
            data-testid="Loading"
        >
            <CircularProgress {...props} />
        </div>
    )
}

export default Loading
